import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {ItemKey} from "../item/core/ItemKey";
import {Schema} from "@/common/Schema";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";


export class RewardGeneratorConfig extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(RewardGeneratorConfig, v) : SKIP;
        }, (v) => {
            return deserialize(RewardGeneratorConfig, v);
        });
    }

    constructor() {
        super();

        this._item = null;
        this._itemCluster = null;

        this._card = null;
        this._cardCluster = null;
        this._cardPackage = null;

        this._currencyKind = null;

        this._amount = "1";
        this._percent = 100;
    }

    get item() {
        return this._item;
    }

    set item(value) {
        this._item = value;
    }

    get itemCluster() {
        return this._itemCluster;
    }

    set itemCluster(value) {
        this._itemCluster = value;
    }

    get card() {
        return this._card;
    }

    set card(value) {
        this._card = value;
    }

    get cardCluster() {
        return this._cardCluster;
    }

    set cardCluster(value) {
        this._cardCluster = value;
    }

    get cardPackage() {
        return this._cardPackage;
    }

    set cardPackage(value) {
        this._cardPackage = value;
    }

    get currencyKind() {
        return this._currencyKind;
    }

    set currencyKind(value) {
        this._currencyKind = value;
    }

    get amount() {
        return this._amount
    }

    set amount(value) {
        this._amount = value;
    }

    get percent() {
        return this._percent;
    }

    set percent(value) {
        this._percent = value;
    }

    valid() {

        if (this.targetCount() !== 1) {
            return false
        }

        if (this.item && (!this.item.valid() || this.item.any())) {
            return false;
        }

        if (this.item && !RedactorUtils.getItems().some(item => item.key?.equal(this.item))) {
            console.log('Invalid config: Missing Item for Reward generator item');
            return false;
        }

        if (this.itemCluster && !RedactorUtils.getItemCluster(this.itemCluster)) {
            return false;
        }

        if (this.card && !RedactorUtils.getCard(this.card)) {
            return false;
        }

        if (this.cardCluster && !RedactorUtils.getCardCluster(this.cardCluster)) {
            return false;
        }

        if (this.cardPackage && !RedactorUtils.getCardPackage(this.cardPackage)) {
            return false;
        }

        if (this.currencyKind && !CurrencyKindModel.is(this.currencyKind)) {
            return false;
        }

        if (this.amount.trim() === '') {
            return false;
        }

        if (!Number.isInteger(this.percent) || this.percent <= 0 || this.percent > 100) {
            return false;
        }

        return true;
    }

    targetCount() {
        let value_count = 0;
        value_count += (this.item ? 1 : 0);
        value_count += (this.itemCluster ? 1 : 0);

        value_count += (this.card ? 1 : 0);
        value_count += (this.cardCluster ? 1 : 0);
        value_count += (this.cardPackage ? 1 : 0);

        value_count += (this.currencyKind ? 1 : 0);

        return value_count;
    }

    empty() {
        return !(this.item || this.itemCluster || this.card || this.cardCluster || this.cardPackage || this.currencyKind);
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new RewardGeneratorConfig());
        } else if (target instanceof RewardGeneratorConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(RewardGeneratorConfig, {
    _item: alias("item", ItemKey.schema()),
    _itemCluster: alias("cluster", Schema.primitive()),

    _card: alias("card", Schema.primitive()),
    _cardCluster: alias("card_cluster", Schema.primitive()),
    _cardPackage: alias("card_package", Schema.primitive()),

    _currencyKind: alias("currency_kind", CurrencyKindModel.schema()),

    _amount: alias("amount", Schema.primitive()),
    _percent: alias("percent", Schema.primitive())
});
